<template>
  <section class="noPadding">
    <!-- busqueda --->
    <div class="row justify-content-center" style="margin-top:2%">
      <!-- keywords -->
      <div class="col-12">
        <h4 class="title-card" style="color: white;">
          *Separa con comas las palabras a buscar
        </h4>
      </div>
      <div class="col-sm-12 col-md-11 col-lg-11">
        <div class="card head-card keywords-section">
          <div class="title-card">
            <h4>Keywords</h4>
          </div>
          <div class="card-content">
            <div class="row justify-content-center">
              <div class="col-sm-12 col-md-8">
                <div class="inputype Keywords-input">
                  <form>
                    <input type="text " v-on:keydown.enter.prevent="addKeyword" v-model="keyword"
                      placeholder="ej. Mi Keyword" @change="
                        (val) => {
                          addKeyword(val);
                        }
                      " />
                  </form>
                </div>
              </div>

              <div class="col-sm-12 col-md-4">
                <div class="Keywords-button-container">
                  <button :class="[
                    'button',
                    'fluid',
                    'alternative',
                    'noMargin',
                    keyword ? '' : 'disabled',
                  ]" @click="() => editar()" :disabled="keyword == ''" v-if="search.query">
                    Buscar
                  </button>

                  <button :class="[
                    'button',
                    'fluid',
                    'alternative',
                    'noMargin',
                    keyword ? '' : 'disabled',
                  ]" @click="() => buscar()" :disabled="keyword == ''" v-else>
                    Buscar
                  </button>
                </div>
              </div>

              <!-- <div class="col-sm-6 col-md-4 ">
                                <div class="checkbox checkAND noPadding" style="background:red!important">
                                    <label class="active" style="padding-left:20px">
                                        <div class="user-avatar">
                                            <div class="data-avatar">Contiene todas las etiquetas</div>
                                        </div>
                                        <input class="box" type="checkbox" :checked="andQuery" @click="selectAND()" />

                                        <span class="nbox checkElement" style="left:0!important">
                                            <svg viewBox="0 0 14.018 13.003">
                                                <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                    transform="translate(-304.98 -380.994)" fill="#fff" />
                                            </svg>
                                        </span>
                                    </label>
                                </div>
                            </div> -->

              <div class="col-sm-6  col-md-3 noPadding">
                <div class="checkbox checkAND noPadding">
                  <label class="active" style="padding-left:20px">
                    <div class="user-avatar">
                      <div class="data-avatar">Medios Online</div>
                    </div>
                    <input class="box" type="checkbox" v-model="online" @click="
                      () => {
                        online = !online;
                      }
                    " :disabled="favoritos || entidad || grupo" />

                    <span class="nbox checkElement" style="left:0!important">
                      <svg viewBox="0 0 14.018 13.003">
                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)" fill="#fff" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>

              <div class="col-sm-6  col-md-3 col-lg-3 noPadding">
                <div class="checkbox checkAND">
                  <label class="active" style="padding-left:20px">
                    <div class="user-avatar">
                      <div class="data-avatar">Medios Offline</div>
                    </div>
                    <input class="box" type="checkbox" v-model="offline" @click="
                      () => {
                        offline = !offline || entidad || grupo;
                      }
                    " :disabled="favoritos" />
                    <span class="nbox checkElement" style="left:0!important">
                      <svg viewBox="0 0 14.018 13.003">
                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)" fill="#fff" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
              <!-- EGM241216-->
              <div class="col-sm-6  col-md-3 col-lg-3 noPadding">
                <div class="checkbox checkAND">
                  <label class="active" style="padding-left:20px">
                    <div class="user-avatar">
                      <div class="data-avatar">Favoritos</div>
                    </div>
                    <input class="box" type="checkbox" v-model="favoritos" @click="selFavoritos" />
                    <span class="nbox checkElement" style="left:0!important">
                      <svg viewBox="0 0 14.018 13.003">
                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)" fill="#fff" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
              <!--EGM-->
              <div class="col-sm-6 col-md-3 col-lg-3 noPadding">
                <div class="checkbox checkSM">
                  <label class="active" style="padding-left:20px">
                    <div class="user-avatar">
                      <div class="data-avatar">Seleccionar medios</div>
                    </div>
                    <input class="box" type="checkbox" v-model="advanced" @click="goTo" :disabled="favoritos" />
                    <span class="nbox checkElement" style="left:0!important">
                      <svg viewBox="0 0 14.018 13.003">
                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)" fill="#fff" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>

              <!-- <div class="col-12">
                                <div class="chip-button">
                                    <div class="chip primary iconed" v-for="(item, index) in keywords" v-bind:key="index">
                                        {{ item }}
                                        <button class="icon" @click="() => removeKeyword(index)">
                                            <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                                                <line x1="16" y1="8" x2="8" y2="16" />
                                                <line x1="8" y1="8" x2="16" y2="16" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div> -->
            </div>
            <div class="row">
              <div class="col-sm-6 col-md-4 col-lg-4" v-if="!favoritos">
                <div class="mi-select-egm">
                  <v-select :value="entidad" :reduce="(option) => option.value" :searchable="false" :filterable="false"
                    :clearable="true" class="style-chooser" :options="options3" @input="setSelectedRegion"
                    placeholder="Todas las entidades">
                  </v-select>
                </div>
              </div>
               <div class="col-sm-6 col-md-4 col-lg-4" v-if="!favoritos">
                <div class="mi-select-egm">
                  <v-select :value="grupo" :reduce="(option) => option" :searchable="false" :filterable="false"
                    :clearable="true" class="style-chooser" :options="dataGrupos" @input="setSelectedGrupo"
                    placeholder="Todos los grupos">
                  </v-select>
                </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3" v-if="!favoritos">
                <div class="checkbox checkAND">
                  <label class="active" style="padding-left:20px">
                    <div class="user-avatar">
                      <div class="data-avatar">Sólo Publicidad</div>
                    </div>
                    <input class="box" type="checkbox" v-model="publicidad" @click="selPublicidad" />
                    <span class="nbox checkElement" style="left:0!important">
                      <svg viewBox="0 0 14.018 13.003">
                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                          d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                          transform="translate(-304.98 -380.994)" fill="#fff" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- horario -->
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-11 col-lg-11">
        <div class="card head-card time-section">
          <div class="title-card">
            <h4>Tiempo</h4>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-12 col-md-8 col-lg-8">
                <div class="calendar-container">
                  <h4 class="interiorTitle">
                    Selecciona el rango de fecha para la búsqueda
                  </h4>
                  <select v-model="dselected" class="dselected" @change="selectRange()">
                    <option value="7">Ultimos 7 días</option>
                    <option value="15">Ultimos 15 días</option>
                    <option value="30">Ultimos 30 días</option>
                    <option value="60">Ultimos 60 días</option>
                    <option value="rango">Rango personalizado</option>
                  </select>
                  <br />
                  <v-date-picker :columns="$screens({ default: 1, lg: 2 })" color="gray" is-inline v-model="range"
                    mode="range" :min-date="getMinDate" v-if="dselected == 'rango'" />
                  <div class="range" v-show="start" v-if="dselected == 'rango'">
                    Del {{ start }} a {{ end }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4">
                <div class="text-center">
                  <h4 class="interiorTitle">Horario</h4>
                  <div class="row no-glutters">
                    <div class="col-6">
                      <input class="radioB" type="radio" id="uno" value="todo" v-model="hpicked" @change="hchange" />
                      <label for="checkbox">Todo el día</label>
                    </div>
                    <div class="col-6">
                      <input class="radioB" type="radio" id="uno" value="rango" v-model="hpicked" />
                      <label for="checkbox">Rango</label>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center" v-if="hpicked == 'rango'">
                  <div class="col-auto">
                    <div class="select-container">
                      <h4 class="labelTitle">Hora inicio</h4>
                      <vue-timepicker v-model="hini" @input="changeHour" format="HH:mm"></vue-timepicker>
                    </div>
                  </div>
                  <div class="col-auto">
                    <div class="select-container">
                      <h4 class="labelTitle">Hora final</h4>
                      <vue-timepicker v-model="hfin" @input="changeHour" format="HH:mm"></vue-timepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- alertas -->
    <div class="row  justify-content-center">
      <div class="col-sm-12 col-md-11 col-lg-11">
        <div class="card head-card alerts-section">
          <div class="title-card">
            <h4>Alertas</h4>
          </div>
          <div class="card-content">
            <div class="collapsible ">
              <div class="trigger bOscuro alerta">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="trigger-icon">
                      <font-awesome-icon icon="envelope" />
                    </div>
                  </div>
                  <div class="col">
                    <div class="trigger-content">Enviar por correo</div>
                  </div>
                  <div class="col-auto touchpad">
                    <div class="checkbox ">
                      <label class="active noPadding">
                        <input class="box" type="checkbox" v-model="checkEmail" @click="selectAlert(0)" />

                        <span class="nbox checkElement">
                          <svg viewBox="0 0 14.018 13.003">
                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                              d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                              transform="translate(-304.98 -380.994)" fill="#fff" />
                          </svg>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="['body', { hide: !checkEmail }]">
                <div class="row">
                  <div class="col-12">
                    <div class="text-center">
                      <div class="row no-glutters">
                        <div class="col-6">
                          <input class="radioB" type="radio" id="typeEmail" value="correos"
                            v-model="pickedTypeEmails" />
                          <label for="checkbox">Correos</label>
                        </div>
                        <div class="col-6">
                          <input class="radioB" type="radio" id="typeEmail" value="grupos" v-model="pickedTypeEmails" />
                          <label for="checkbox">Grupos</label>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row justify-content-center">
                      <div class="col-sm-12 col-md-6">
                        <div class="inputype Keywords-input">
                          <form action>
                            <!--<input
                              type="text "
                              v-model="input"
                              v-on:keydown.enter.prevent="addEmailFromInput"
                              :placeholder="
                                pickedTypeEmails == 'correos'
                                  ? 'nombre@email.com'
                                  : 'nombre grupo'
                              "
                            />-->
                            <v-content>
                              <div class="scrollable-select" :style="{ height: toggleSelect ? '300px' : 'auto' }">
                                <v-select :value="cogp" :searchable="false" :filterable="false" :clearable="true"
                                  :options="resultsCoGp" @input="addItem" placeholder="Correos o grupos x"
                                  :append-to-body="true" class="scrollable-select"
                                  v-on:open="toggleSelect = !toggleSelect" v-on:close="toggleSelect = !toggleSelect" />
                              </div>
                            </v-content>
                          </form>
                        </div>
                      </div>

                      <!--<div class="col-sm-6 col-md-3">
                        <button
                          :class="['button', 'noMargin', 'tooltip']"
                          data-tooltip="Agregar Email"
                          @click="agregarEmail()"
                          v-if="addEmail"
                        >
                          <font-awesome-icon icon="plus" />
                        </button>
                        <button
                          :class="[
                            'button',
                            { alternative: items.length == 0 },
                            'noMargin',
                            'tooltip',
                          ]"
                          data-tooltip="Todos"
                          @click="setAll"
                        >
                          <font-awesome-icon icon="globe-americas" />
                        </button>
                      </div>-->
                    </div>
                    <!--<div class="row">
                      <div class="chip-button">
                        
                        <div
                          class="chip iconed touchpad"
                          @click="addItem(item)"
                          v-for="(item, index) in results"
                          v-bind:key="'result' + index"
                        >
                          {{ item.nombre ? item.nombre : item.key }}<br />
                          {{
                            pickedTypeEmails == "correos" && item.nombre
                              ? item.key
                              : ""
                          }}
                        </div>
                      </div>
                    </div>-->
                    <br />

                    <div class="row" style="border-top:1px solid #00B99E" v-if="items.length > 0">
                      <div class="col-12">
                        <h4>Correos a enviar:</h4>

                        <div class="chip-button">
                          <div class="chip iconed touchpad" v-for="(item, index) in items" v-bind:key="'items' + index">
                            {{ item.nombre ? item.nombre : item.key }}
                            <br />
                            {{
                              pickedTypeEmails == "correos" && item.nombre
                                ? item.key
                                : ""
                            }}
                            <button class="icon" @click="() => removeItem(index)">
                              <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-x">
                                <line x1="16" y1="8" x2="8" y2="16" />
                                <line x1="8" y1="8" x2="16" y2="16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="collapsible">
              <div class="trigger bOscuro alerta">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="trigger-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22"
                        class="main-grid-item-icon" fill="none">
                        <path
                          d="M6.579 8.121c.209-.663.778-1.457 1.19-1.66.183-.09.319-.11.763-.11.522 0 .548.005.684.14.088.095.328.606.673 1.432.292.71.533 1.315.533 1.347 0 .146-.293.61-.627 1.002-.23.267-.365.47-.365.543 0 .068.167.381.376.69.506.757 1.44 1.696 2.167 2.177.568.376 1.582.867 1.785.867.152 0 .429-.272.992-.982.23-.287.434-.495.512-.511.068-.021.235.005.37.057.392.152 2.371 1.117 2.476 1.211.203.188.037 1.264-.267 1.702-.464.68-1.79 1.259-2.663 1.17-.636-.068-2.14-.564-3.117-1.029-1.253-.6-2.574-1.697-3.644-3.038-.611-.763-1.227-1.692-1.493-2.246-.36-.751-.491-1.331-.455-2 .016-.287.068-.631.11-.762Z"
                          fill="#ffffff" />
                        <path clip-rule="evenodd"
                          d="M.606 9.5C1.582 4.491 5.576.76 10.709.06c.705-.1 2.684-.068 3.368.046.715.126 1.66.371 2.24.59 3.832 1.426 6.663 4.72 7.466 8.683.35 1.729.272 3.755-.203 5.457-1.133 4.03-4.423 7.205-8.511 8.218-2.663.658-5.462.37-7.983-.81l-.617-.292-3.226 1.029C1.473 23.545.01 23.994 0 23.983c-.01-.01.45-1.415 1.029-3.112l1.05-3.096-.424-.84C.48 14.569.12 12.01.605 9.498Zm21.172-.408c-1.028-3.76-4.297-6.626-8.145-7.148-2.099-.282-4.078.037-5.9.956-4.417 2.234-6.522 7.341-4.93 11.957.204.59.752 1.702 1.092 2.213l.271.408-.605 1.775a69.688 69.688 0 0 0-.606 1.817c0 .026.84-.224 1.864-.548a99.767 99.767 0 0 1 1.9-.596c.022 0 .225.11.45.24 2.428 1.447 5.456 1.76 8.187.852a9.927 9.927 0 0 0 6.48-6.945 9.998 9.998 0 0 0-.058-4.98Z"
                          fill="#ffffff" fill-rule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div class="col">
                    <div class="trigger-content"> <!-- Se mantiene fijo EGM 230126 -->
                      Enviar notificacion por WhatsApp
                    </div>
                  </div>
                  <div class="col-auto touchpad">
                    <div class="checkbox ">
                      <label class="active noPadding">
                        <input class="box" type="checkbox" v-model="checkwhatsapp" @click="selectAlert(1)" />

                        <span class="nbox checkElement">
                          <svg viewBox="0 0 14.018 13.003">
                            <path id="Rectángulo_9" data-name="Rectángulo 9"
                              d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                              transform="translate(-304.98 -380.994)" fill="#fff" />
                          </svg>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- card alertas -->
      </div>
    </div>
    <confirm :show="show" :smsModal="smsModal" @aceptar="deleteSearch" @cancelar="cancelDelete"></confirm>
    <!-- <div class="row justify-content-center">
            <div class="col-sm-12 col-md-6 col-lg-6">

                <button class="button fluid" @click="editar" v-if="search.query">
                    Guardar Cambios
                </button>
                <button class="button fluid" @click="buscar" v-else>
                    Buscar
                </button>
            </div>
        </div> -->
  </section>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import confirm from "@/components/confirm";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faGlobeAmericas,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

library.add(faEnvelope);
library.add(faGlobeAmericas);
library.add(faPlus);

import moment from "moment";
import { wrap } from "lodash";

export default {
  props: ["search"],
  components: { VueTimepicker, confirm },
  data() {
    return {
      //axios
      url: this.$store.getters.getMainUrl,
      providerID: this.$store.state.userInfo.net,
      advanced: false,
      //checkboxes
      online: true,
      offline: true,
      //keywords
      keywords: "",
      keyword: "",
      //tiempo
      rSelected: false,
      hini: "00:00",
      hfin: "23:59",
      dselected: 60,
      hpicked: "todo",
      range: {
        start: null, // Jan 16th, 2018
        end: null, // Jan 19th, 2018
      },
      start: null,
      end: null,
      //alerts
      checkEmail: false,
      checkwhatsapp: false,
      pickedTypeEmails: "",
      cmd: "",
      items: [],
      itemsKey: [],
      LastEvaluatedKey: null,
      selectedIndex: -1,
      input: "",
      all: true,
      results: [],
      resultsCoGp: [],
      miSearch: {},
      eq: {
        FB: "facebook",
        TW: "twitter",
        // "I": "instagram",
        Y: "youtube",
        PD: "noticieros",
        R: "radio",
        T: "tv",
        TK: "tiktok",
      },
      onlineArr: [],
      onlineArrDefault: ["FB", "TW", "Y", "PD", "TK"],
      offlineArr: [],
      offlineArrDefault: ["T", "R"],
      addEmail: false,
      andQuery: this.$store.state.projectConfig.andQuery,
      show: false,
      smsModal:
        "¿Desea eliminar todas la notificacion de whatsapp que este relacionada a la búsqueda?",
      favoritos: false,
      favoritosFi: {},
      url: this.$store.getters.getMainUrl,
      entidades: {
        activo: false,
        id: null,
      },
      selecGrupo: {
        activo: false,
        label: false,
        id: null,
      },
      options3: [],
      entidad: null,
      grupo: null,
      cogp: null,
      toggleSelect: false,
      publicidad: false,
      dataGrupos: [],
    };
  },
  computed: {
    getMinDate() {
      var today = moment();
      var minF = today.subtract(60, "days");
      var minDate = new Date(minF);
      return minDate;
    },
    token() {
      return this.$store.getters.getToken;
    },
  },
  beforeMount() {
    this.$store.commit("clearProyectConfig");
    if (this.search.query) {
      this.keyword = this.search.query.keywords;
      console.log(this.search);
      this.miSearch = this.search;
      this.armarMediosFi(this.search.query.fi);
      this.setConfig();
    } else {
      //valores predeterminados
      this.pre();
    }
    this.getMediaRegiones();
    this.getMediaGroups();
    console.log("mounted search");
    this.input_alterno();

  },
  watch: {
    online() {
      this.setOnline(this.online);
    },
    offline() {
      this.setOffline(this.offline);
    },
    dselected() {
      this.$store.commit("addrDias", this.dselected);
    },
    range(val) {
      console.log("range changed", val);
      if (val) {
        let d = new Date(val.start);
        let de = new Date(val.end);
        let ms = d.getMonth() + 1;
        let me = de.getMonth() + 1;
        if (ms <= 9) ms = "0" + ms;
        if (me <= 9) me = "0" + me;

        let ds = d.getDate();
        let dend = de.getDate();

        if (ds <= 9) ds = "0" + ds;
        if (de <= 9) de = "0" + de;

        this.start = ds + "/" + ms + "/" + d.getFullYear();
        this.end = dend + "/" + me + "/" + de.getFullYear();

        var dates = {
          ini: d.getFullYear() + "-" + ms + "-" + ds,
          fin: de.getFullYear() + "-" + me + "-" + dend,
        };
        this.$store.commit("addRange", dates);
      }
    },
    /*input() {
      console.log("input_alterno");
      if (this.input.trim() == "") {
        this.results = [];
        return 0;
      }

      var self = this;
      var post_data = {
        token: this.token,
        //nombre: this.input,
      };
      var cmd = getEmails; //"searchEmail"; //getEmails
      if (this.pickedTypeEmails == "grupos") cmd = "getGroups"; //"searchGroup";
      axios
        .post(self.url + cmd, JSON.stringify(post_data))
        .then(function(response) {
          self.isLoading = false;
          console.log(response);
          if (response.data.success){
             self.results = response.data.data.result;
             for (const item of self.results) {
              var rr = {
               "label": item.nombre,
               "key": item.key
              }
              self.resultsCoGp.push(rr);
          }
        }
          else self.error(response.data.error);
          //self.LastEvaluatedKey = (response.data.data.LastEvaluatedKey)?  response.data.data.LastEvaluatedKey:null;
          if (self.results.length == 0) {
            self.addEmail = self.verificaEmail(self.input) ? true : false;
          } else {
            self.addEmail = false;
          }
        })
        .catch(function(error) {
          self.isLoading = false;
          self.error(error);
        });
    },*/
    pickedTypeEmails() {
      //console.log(this.pickedTypeEmails,"#######");
      this.clear();
      if (this.pickedTypeEmails == "correos") {
        this.cmd = "getEmails";
        this.input_alterno();

      } //this.getItems();}
      if (this.pickedTypeEmails == "grupos") {
        this.cmd = "getGroups";
        this.input_alterno();

      } //this.getItems();}
    },
  },
  methods: {
     getMediaGroups() { ///EGM290823
      //sliders de canales
      console.log("grupos")
      var self = this;
      //var arrFavs = [];
      axios
        .post(self.url + "getMediaGroups", JSON.stringify({ token: self.token, medio: ""}))
        .then(response => {
          if (response.data.success) {
            self.dataGrupos = self.dataGrupos.concat(response.data.data) //EGM290823
            //self.items = response.data.result;
          } else {
            //self.items = [].concat(self.items, response.data.result);
          }

        })
        .catch(function (error) {
          self.error(error);
        });
    },
    getMediaRegiones() {
      ///EGM290823
      //sliders de canales
      this.options3 = [];
      var self = this;
      //var arrFavs = [];
      axios
        .post(
          self.url + "getMediaCiudadRegion",
          JSON.stringify({ token: self.token, medio: this.medio, grupo: 0 })
        )
        .then((response) => {
          console.log("-------------------HERRE");
          console.log(response.data);
          //self.ready = true;
          if (response.data.success) {
            self.options3 = response.data.data; //EGM290823
            //self.items = response.data.result;
          } else {
            //self.items = [].concat(self.items, response.data.result);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    setSelectedRegion(value) {
      this.online = true;
      this.medioOfline = false;
      this.favoritos = false;
      this.entidades["activo"] = true;
      this.entidades["id"] = value;
      this.entidad = value;
    },
    setSelectedGrupo(datos) {
      console.log("=======seleccion canale",datos.value)
      this.online = true;
      this.medioOfline = false;
      this.favoritos = false;
      this.selecGrupo["activo"] = true;
      this.selecGrupo["id"] = datos.value;
      this.selecGrupo["label"] = datos.label;
      this.grupo = datos.label;
    },
    async armarMediosFi(fiM) {
      await this.getPermisosValid();
      // console.log(fiM);
      // var MTempoOnline = [];
      // var MtempoOffline=[];
      // for (let element in fiM) {
      //     // "FB","I","TW","Y","PD","TK"
      //     // "T","R"
      //     if(element == "FB" || element == "I" || element == "TW" || element == "Y" || element == "PD" || element == "TK"){
      //         MTempoOnline.push(element)
      //     }
      //     if( element == "T" || element == "R"){
      //         MtempoOffline.push(element);
      //     }
      // }
      // // this.online = MTempoOnline;
      // // this.offline = MtempoOffline;
      // this.onlineArr = MTempoOnline;
      // this.offlineArr = MtempoOffline;
      // // this.setOffline(this.offline);
      // // this.setOnline(this.online);
    },

    async pre() {
      await this.getPermisosValid();
      console.log("<=======pre=========>");
      this.setOffline(this.offline);
      this.setOnline(this.online);
    },
    async setConfig() {
      console.log("setConfig", this.miSearch.query);

      var query = this.miSearch.query;

      this.checkwhatsapp = query.alertWP;
      this.$store.commit("setNoWP", query.alertWP);
      this.andQuery = query.andQuery;
      this.$store.commit("saveAND", this.andQuery);
      this.keywords = query.keywords;
      this.$store.commit("addKeywords", this.keywords);

      this.dselected = query.dias;
      this.$store.commit("addrDias", this.dselected);

      var fiParams = query.fiParams;
      console.log("fiParams");
      console.log(fiParams);
      for (var j in fiParams) {
        this.$store.commit("addfiParams", { mt: j, arr: fiParams[j] });
      }
      console.log(this.$store.state.projectConfig.fiParams);
      if (this.dselected == "rango") {
        var fecha = {
          ini: "",
          fin: "",
        };
        var fecha_arr = query.fecha.ini.split("-");
        var anio = fecha_arr[0];
        var mes = parseInt(fecha_arr[1]);
        var dia = parseInt(fecha_arr[2]);
        if (mes <= 9) mes = "0" + mes;
        if (dia <= 9) dia = "0" + dia;

        this.start = dia + "/" + mes + "/" + anio;
        this.range.start = new Date(anio, parseInt(mes) - 1, dia);
        fecha.ini = anio + "-" + mes + "-" + dia;

        var fecha_arr = query.fecha.fin.split("-");
        var anio = fecha_arr[0];
        var mes = parseInt(fecha_arr[1]);
        var dia = parseInt(fecha_arr[2]);
        if (mes <= 9) mes = "0" + mes;
        if (dia <= 9) dia = "0" + dia;
        this.end = dia + "/" + mes + "/" + anio;
        this.range.end = new Date(anio, parseInt(mes) - 1, dia);
        fecha.fin = anio + "-" + mes + "-" + dia;
        this.$store.commit("addRange", fecha);
      }
      if (query.hora) {
        this.hpicked =
          query.hora.ini == "00:00" && query.hora.fin == "23:59"
            ? "todo"
            : "rango";
        this.hini = query.hora.ini;
        this.hfin = query.hora.fin;
        var time = {
          ini: this.hini,
          fin: this.hfin,
        };
        this.$store.commit("addTime", time);
      }
      var online = this.onlineArr;
      var offline = this.offlineArr;

      var cont1 = 0;
      var cont2 = 0;
      var fi = query.fi;
      for (var i in online) {
        var red = online[i];
        if (fi[red]) {
          if (red == "PD") this.$store.dispatch("selectNoticieros");
          else this.$store.dispatch("selectMedia", this.eq[red]);
          let data = {
            mt: red,
            arr: fi[red],
          };
          this.$store.commit("setfiSelect", this.eq[red]);
          this.$store.commit("addMedia", data);
          if (fi[red].length == 0) {
            cont1++;
          }
        }
      }
      for (var i in offline) {
        var red = offline[i];
        if (fi[red]) {
          if (red == "T") this.$store.dispatch("selectTV");
          else this.$store.dispatch("selectRadio");
          let data = {
            mt: red,
            arr: fi[red],
          };
          this.$store.commit("setfiSelect", this.eq[red]);
          this.$store.commit("addMedia", data);
          if (fi[red].length == 0) {
            cont2++;
          }
        }
      }

      if (query.alerta == true) {
        this.checkEmail = true;
        this.pickedTypeEmails = query.alertType;
        this.itemsKey = query.alertKeys;

        var results = [];
        for (var i in this.itemsKey) {
          console.log("jasjsjs");
          console.log(this.itemsKey[i]);
          //var result = await this.getItem({ type:query.alertType,key: this.itemsKey[i] });
          //console.log('result getItem');
          //console.log(result);
          //if(result.success)
          //    results.push(result.data);
          //else
          results.push({
            //key:new Date().getTime(),
            nombre: this.itemsKey[i],
          });
        }
        console.log(results);
        this.items = results;
      }

      this.online = false;
      this.offline = false;
      console.log(cont1);
      console.log(cont2);
      if (online.length == cont1) this.online = true;
      if (offline.length == cont2) this.offline = true;
      console.log("projectConfig");
      console.log(this.$store.state.projectConfig);

      if (this.online == false && this.offline == false) {
        this.$store.commit("saveQuery", query);
        this.$store.dispatch("setMode", "edit");
        this.$store.dispatch("setKey", this.search.key);
        this.$router.push({
          name: "busqueda",
          params: { step: "step1" },
        });
      }
    },
    async getItem(obj) {
      console.log("getItem");
      var post_data = {
        token: this.token,
        type: obj.type,
        key: obj.key,
      };
      var self = this;
      return new Promise((resolve, reject) => {
        axios
          .post(self.url + "getAlert", JSON.stringify(post_data))
          .then(function (response) {
            if (response.data.success) {
              resolve({ success: true, data: response.data.data });
            } else {
              resolve({ success: false, data: response.data.error });
            }
          })
          .catch(function (error) {
            resolve({ success: false, error: error });
          });
      });
    },
    async buscar() {
      console.log("buscar nuevo origen");
      if (this.input.trim() != "") {
        this.error("Falta por agregar el email: " + this.input);
        return 0;
      }
      var gaugeQuery = await this.getQuery();

      if (gaugeQuery) this.$emit("buscar", gaugeQuery, this.checkwhatsapp);
    },

    //////
    async getCanalesEntidades() {
      try {
        var post_data = {
          id_entidad: this.entidades.id
        };
        if (this.online) {
          post_data.medioOn = true
        }
        if (this.offline) {
          post_data.mediOf = true
        }
        const response = await axios.post(
          this.url + "getCanalesEntidadesV2",
          JSON.stringify(post_data)
        );
        console.log("Datos recibidos:", response.data);
        return response.data; // Retorna los datos para su uso
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        throw error; // Propaga el error para manejarlo fuera
      }
    },
    async getQuery() {
      if (this.keyword == "") {
        this.error("Agregue un keyword");
        return 0;
      }
      console.log("EGM", this.favoritos);

      if (
        this.online == false &&
        this.offline == false &&
        this.favoritos == false
      ) {
        this.error("Seleccione un medio");
        return 0;
      }

      let time = {
        ini: this.hini,
        fin: this.hfin,
      };

      var gaugeQuery = {
        ubicacion: "global",
        hora: time,
        keywords: this.keyword,
        logs: true,
      };

      if (this.dselected == "rango") {
        if (this.range.start == null) {
          this.error("Seleccione un rango de inicio");
          return 0;
        }
        if (this.range.end == null) {
          this.error("Seleccione un rango de fin");
          return 0;
        }
        let d = new Date(this.range.start);
        let de = new Date(this.range.end);
        let ms = d.getMonth() + 1;
        let me = de.getMonth() + 1;
        let start = d.getFullYear() + "-" + ms + "-" + d.getDate();
        let end = de.getFullYear() + "-" + me + "-" + de.getDate();
        let dates = {
          ini: start,
          fin: end,
        };
        gaugeQuery.fecha = dates;
        gaugeQuery.dias = "rango";
      } else {
        gaugeQuery.dias = this.dselected;
      }

      // redes?
      var fi = {};
      if (this.online) {
        //TW,FB,Y,I,PD
        this.onlineArr.forEach((element) => {
          fi[element] = [];
        });
        // fi = {
        //     "TW": [],
        //     "FB": [],
        //     "Y": [],
        //     "I": [],
        //     "PD": [],
        //     "TK": []
        // }
      }

      if (this.favoritos) {
        fi = this.favoritosFi;
      }
      if (this.selecGrupo.activo) {
        if (this.selecGrupo.id) {
        
           gaugeQuery.grupo = this.selecGrupo;
        }
      }
      if (this.entidades.activo) {
        if (this.entidades.id) {
          if (this.offline) {
            const datos = await this.getCanalesEntidades();
            console.log("#####", datos)
            if (datos.success) {
              gaugeQuery.fiParams = {};


              if (datos.data.T.length) {
                fi.T = datos.data.T;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ T: [0, 0] }
                }
              } else {
                delete fi.T;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ T: [1, 1] }
                }
              }

              if (datos.data.R.length) {
                fi.R = datos.data.R;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ R: [0, 0] }
                }
              } else {
                delete fi.R;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ R: [1, 1] }
                }
              }

              if (datos.data.FB.length) {
                fi.FB = datos.data.FB;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ FB: [0, 0] }
                }
              } else {
                delete fi.FB;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ FB: [1, 1] }
                }
              }

              if (datos.data.I.length) {
                fi.I = datos.data.I;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ I: [0, 0] }
                }
              } else {
                delete fi.I;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ I: [1, 1] }
                }
              }

              if (datos.data.TK.length) {
                fi.TK = datos.data.TK;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ TK: [0, 0] }
                }
              } else {
                delete fi.TK;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ TK: [1, 1] }
                }
              }

              if (datos.data.Y.length) {
                fi.Y = datos.data.Y;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ Y: [0, 0] }
                }
              } else {
                delete fi.Y;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ Y: [1, 1] }
                }
              }

              if (datos.data.PD.length) {
                fi.PD = datos.data.PD;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ PD: [0, 0] }
                }
              } else {
                delete fi.PD;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ PD: [1, 1] }
                }
              }

              if (datos.data.TW.length) {
                fi.TW = datos.data.TW;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ TW: [0, 0] }
                }
              } else {
                delete fi.TW;
                gaugeQuery.fiParams = {
                  ...gaugeQuery.fiParams,
                  ...{ TW: [1, 1] }
                }
              }
            }
            gaugeQuery.entidades = this.entidades;
          }
        } else {
          if (this.offline) {
            //T,R
            if (!this.favoritos) {
              this.offlineArr.forEach((element) => {
                fi[element] = [];
              });
            }
          }
        }
      } else {
        if (this.offline) {
          //T,R
          if (!this.favoritos) {
            this.offlineArr.forEach((element) => {
              fi[element] = [];
            });
          }
        }
      }
      console.log("===================", fi, "===========================");

      gaugeQuery.fi = fi;
      //seleccionó alerta?
      console.log("alerta?======>>>>");

      if (this.checkEmail) {
        var r = await this.sendEmails(gaugeQuery);
        if (r.success == false) {
          this.error("Error al enviar emails");
          return 0;
        } else {
          gaugeQuery.alerta = true;
          gaugeQuery.alertType = this.pickedTypeEmails;
          gaugeQuery.alertKeys = this.itemsKey;
          this.success("Email Enviado");
        }
      }
      gaugeQuery.publicidad = this.publicidad;
      gaugeQuery.andQuery = this.$store.state.projectConfig.andQuery;
      return gaugeQuery;
    },
    addKeyword() {
      // if (this.keyword != "") {
      //     this.keywords.push(this.keyword);
      //     this.$store.commit("addKeywords", this.keywords);
      //     this.keyword = "";
      // }
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
      this.$store.commit("addKeywords", this.keywords);
    },
    changeHour(data) {
      var time = {
        ini: this.hini,
        fin: this.hfin,
      };
      this.$store.commit("addTime", time);
    },
    hchange() {
      this.hini = "00:00";
      this.hfin = "23:59";
      var time = {
        ini: this.hini,
        fin: this.hfin,
      };
      this.$store.commit("addTime", time);
    },
    selectRange() {
      this.rSelected = true;
    },
    cancelDelete() {
      this.checkwhatsapp = true;
      this.show = false;
    },
    deleteSearch() {
      let key_notifica = this.miSearch.table + "_" + this.miSearch.key;
      var post_data = {
        key: key_notifica,
        token: this.token,
      };
      var self = this;
      axios
        .post(
          self.url + "deleteConfigWa",
          JSON.stringify(post_data)
        )
        .then((response) => {
          self.show = false;
          if (response.data.success) {
            self.success("Notificacion eliminada");
          }
        })
        .catch(function (error) {
          self.show = false;
          self.error(error);
        });
    },
    selectAlert(index) {
      this.selectedIndex = index;
      switch (index) {
        case 0:
          this.checkEmail = !this.checkEmail;
          if (this.checkEmail) {
            this.pickedTypeEmails = "correos";
          } else {
            this.pickedTypeEmails = "";
            this.clear();
          }
          break;
      }
    },
    setAll() {
      if (this.items.length > 0) {
        this.itemsKey = [];
        this.items = [];
        this.results = [];
      }
    },
    clear() {
      this.itemsKey = [];
      this.items = [];
      this.cmd = "";
      this.results = [];
    },
    async sendEmails(query) {
      console.log(this.pickedTypeEmails);
      console.log(this.items);
      var post_data = {
        query: query,
        token: this.token,
        type: this.pickedTypeEmails, //correo o grupos?
        items: this.itemsKey, //array de correos o grupos
      };
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(self.url + "sendEmails", JSON.stringify(post_data))
          .then(function (response) {
            self.isLoading = false;
            console.log(response);
            if (response.data.success) resolve({ success: true });
            else resolve({ success: false, error: response.data.error });
          })
          .catch(function (error) {
            self.isLoading = false;
            resolve({ success: false, error: error });
          });
      });
    },
    removeItem(index) {
      //from alerts
      var i = this.itemsKey.indexOf(this.items[index].key);
      this.itemsKey.splice(i, 1);
      this.items.splice(this.items[index], 1);
    },
    addItem(item) {
      console.log("addItem");
      console.log(item);
      self.addEmail = false;
      if (this.itemsKey.indexOf(item.key) == -1) {
        //no lo ha agregado antes?
        item.nombre = item.label ? item.label : item.nombre;
        this.itemsKey.push(item.key);
        this.items.push(item);
        this.input = "";
        this.results = [];
      } else {
        this.error("ya está agregado");
      }
    },
    //editar busqueda
    async editar() {
      var gaugeQuery = await this.getQuery();
      if (gaugeQuery == 0) return 0;
      //editamos
      console.log(
        this.miSearch.query.alertWP,
        this.checkwhatsapp,
        "####>>>><<zzz<>ZZ"
      );

      console.log(this.search);
      gaugeQuery.alertWP = this.checkwhatsapp;
      var post_data = {
        key: this.search.key,
        query: gaugeQuery,
        token: this.token,
        logs: true,
        version: this.search.version, //EGM-DEV
      };
      console.log(post_data, "***********--------********");
      var self = this;
      axios
        .post(self.url + "editSearch", JSON.stringify(post_data))
        .then(function (response) {
          console.log(response);
          if (response.data.success) {
            self.success("Edición completa");
            if (self.checkwhatsapp) {
              var setNotific = {
                key_busqueda: response.data.data.key,
                table_busqueda: response.data.data.table,
                action: "edit",
                keywords: response.data.data.query.keywords,
                fuentes: response.data.data.query.fi,
                active: true,
                frecuencia: 1,
              };

              self.$store.commit("setNotificacionWp", setNotific);
              self.$router.push("/config-wa");
            } else {
              if (self.miSearch.query.alertWP) {
                self.deleteSearch();
              }
              self.$emit("update", response.data.data);
            }
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    verificaEmail(email) {
      var mail = email.trim();
      var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
      if (pattern.test(mail)) {
        return true;
      } else {
        return false;
      }
    },
    addEmailFromInput() {
      if (this.pickedTypeEmails == "correos") {
        if (this.results.length == 0) {
          if (this.verificaEmail(this.input)) {
            this.agregarEmail();
          } else {
            this.error("Introduce un email válido");
          }
        }
      }
    },
    agregarEmail() {
      if (this.itemsKey.indexOf(this.input) >= 0) {
        this.error("ya está agregado");
        return 0;
      }

      var self = this;
      var item = {
        nombre: "",
        correo: this.input,
        token: this.token,
      };
      axios
        .post(self.url + "addEmail", JSON.stringify(item))
        .then(function (response) {
          console.log("response addEmail");
          console.log(response);
          if (response.data.success) {
            self.items.push(response.data.data);
            self.itemsKey.push(response.data.data.key);
            self.input = "";
            self.addEmail = false;
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error);
        });
    },
    //projectConfig
    setOffline(opc) {
      // console.log(opc, "=====>opc");
      this.offlineArr.forEach((element) => {
        var m = this.eq[element];
        this.$store.dispatch("setMedia", { red: m, opc: opc });
        //  console.log(m, "=======>setOffline");
      });

      // this.$store.dispatch("setMedia", { red: 'radio', opc: opc });
    },
    setOnline(opc) {
      for (var i in this.onlineArr) {
        this.$store.dispatch("setMedia", {
          red: this.eq[this.onlineArr[i]],
          opc: opc,
        });
      }
    },
    selectAND() {
      this.andQuery = !this.andQuery;
      this.$store.commit("saveAND", this.andQuery);
    },
    goTo() {
      this.$store.commit("addKeywords", this.keyword);
      this.$store.commit("addrDias", this.dselected);

      if (this.miSearch.query) {
        this.$store.dispatch("setMode", "edit");
        this.$store.dispatch("setKey", this.search.key);
      } else {
        this.$store.dispatch("setMode", "new");
        this.setOnline(false);
        this.setOffline(false);
      }
      var p = { from: "busquedas" };
      this.$store.commit("saveBack2", p);
      this.$router.push("/busqueda/nueva/step1");
    },
    success(msg) {
      this.$emit("success", msg);
    },
    error(msg) {
      this.$emit("error", msg);
    },
    async getPermisosFeeds() {
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(
            this.url + "getPermisosFeeds",
            JSON.stringify({ token: self.token })
          ) //petición
          .then((response) => {
            self.isLoading = false;
            resolve(response.data);
          })
          .catch(function (error) {
            self.isLoading = false;
            var response = { success: false, error: error };
            console.log(error);
            resolve(response);
          });
      });
    },
    async getPermisosValid() {
      var r = await this.getPermisosFeeds();
      console.log(r, "permisos===>");
      if (r.success) {
        this.onlineArrDefault.forEach((element) => {
          if (r.data.find((p) => p == element)) {
            this.onlineArr.push(element);
          }
        });
        this.offlineArrDefault.forEach((element) => {
          if (r.data.find((p) => p == element)) {
            this.offlineArr.push(element);
          }
        });
      }
    },
    selFavoritos() {
      this.favoritos = !this.favoritos;
      if (this.favoritos) {
        this.online = false;
        this.offline = false;
      } else {
        this.online = true;
        this.offline = true;
      }
      this.getFavoritos();
    },
    selPublicidad() {
      this.publicidad = !this.publicidad;
    },
    getFavoritos() {
      var post_data = {
        token: this.token,
      };

      var self = this;
      axios
        .post(self.url + "getAllfavoritesUser", JSON.stringify(post_data)) //EGM 241211
        .then((response) => {
          console.log("TODOS LOS FAVORITOS");
          console.log(response);
          if (response.data.success) {
            this.favoritosFi = response.data.data;
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    input_alterno() {
      this.results = [];
      this.resultsCoGp = [];

      var self = this;
      var post_data = {
        token: this.token,
        //nombre: this.input,
      };
      //var cmd = "getEmails"; //"searchEmail"; //getEmails
      var cmd = this.cmd != "" ? this.cmd : "getEmails";
      //if (this.pickedTypeEmails == "grupos") cmd = "getGroups"; //"searchGroup";
      axios
        .post(self.url + cmd, JSON.stringify(post_data))
        .then(function (response) {
          self.isLoading = false;
          console.log(response);
          if (response.data.success) {
            self.results = response.data.data.result;
            for (const item of self.results) {
              var rr = {
                "label": item.nombre,
                "key": item.key
              }
              self.resultsCoGp.push(rr);
            }
          }
          else self.error(response.data.error);
          //self.LastEvaluatedKey = (response.data.data.LastEvaluatedKey)?  response.data.data.LastEvaluatedKey:null;
          if (self.results.length == 0) {
            self.addEmail = self.verificaEmail(self.input) ? true : false;
          } else {
            self.addEmail = false;
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error);
        });
    },
  },
};
</script>
<style>
.wrapper>* {
  margin: .1vh 0 30vh;
}

.v-content {
  max-width: 600px;
  margin: 0 auto;
}
</style>